import { AppState } from '../states/app.state';
import { createSelector } from '@ngrx/store';
import { RegionDataState } from '../states/region-data.state';
import { DashboardDataState } from '../states/dashboard-data.state';

const regionData = (state: AppState) => state.regionData;

const dashboardData = (state: AppState) => state.dashboardData;

export const selectRegionData = createSelector(
    regionData,
    (state: RegionDataState) => state.regionData
);

export const selectChartsData = createSelector(
    dashboardData,
    (state: DashboardDataState) => state.dashboardData
);
